<script>
import {getFormat} from "../helpers/format.helper";
import EditableCell from "./EditableCell.svelte";
import AlteryxService from "../services/alteryx.service";
import {onMount} from "svelte";
import Loader from "./Loader.svelte";

let users = [];
let loadingExport = false;
let filter = '';
let loading = true;
let loadingUsers = true;
let errorMessage = '';
let isAllowed = false;

let sortBy = "employees.id";
let order = true;
let headers = [
    {title: "USER ID", key: "employees.id", colSize: 100},
    {title: "USER NAME", key: "employees.name", colSize: 200 },
    {title: "ROLE", key: "role", colSize: 100 },
    {title: "SECTION ID", key: "team_id", colSize: 100 },
    {title: "POSITION", key: "employees.position", colSize: 100 },
    {title: "COMPANY", key: "organization", colSize: 100 },
    {title: "START DATE", key: "employees.start_date", colSize: 100 }
];

onMount( async () => {
    await loadAlteryxCatalog();
});

async function loadAlteryxCatalog() {
    errorMessage = null;
    loading = true;
    users = [];

    try {
        loadingUsers = true;
        const response = await AlteryxService.getUsers({sortBy, order});

        if (response && response.employees) {
            users = response.employees;
        }
    } catch (e) {
        console.log(e);
        errorMessage = e.message;
    } finally {
        loading = false;
        loadingUsers = false;
    }
}

function updateList(e) {
    filter = e.target.value.toString().toLowerCase();
}

function sort(key){
    order = (sortBy === key)? !order : true;
    sortBy = key;
    loadAlteryxCatalog();
}

let exportList = async function(page){
    loadingExport = true;
    try {
        const response = await AlteryxService.export(page);
        if(!response) return false;
        var fields = Object.keys(response[0])
        var replacer = function(key, value) { return value === null ? '' : value }
        var csv = response.map(function(row){
            return fields.map(function(fieldName){
                return JSON.stringify(row[fieldName], replacer)
            }).join(',')
        })
        csv.unshift(fields.join(',')) // add header column
        csv = csv.join('\r\n');
        // Download file
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "alteryx-" + page + ".csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    } catch (e) {
        console.log(e);
        errorMessage = e.message;
    } finally {
        loadingExport = false;
    }
}
</script>
{#if loadingUsers}
    <Loader fixed={false}></Loader>
{:else}
<div class="row">
    <div class="col-10">
        <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Search..." on:keyup={updateList}>
        </div>
    </div>
    <div class="col-2">
        <div class="input-group mb-3 w-auto float-right">
            <button class="btn btn-primary" on:click={() => exportList('userdata')}>
                {#if loadingExport}
                    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                {:else}
                    <img src="/img/csv.svg" alt="csv-icon" class="icon">
                {/if}
                EXPORT
            </button>
        </div>
    </div>
    <div class="col-12">
        {#if users.length > 0}
            <table class="table table-responsive table-scrollable">
                <thead>
                {#each headers as header}
                    <th class="pointer align-top" on:click={() => sort(header.key)} style="min-width: {header.colSize}px">
                        {header.title}
                        <i class="fa fa-sort-{(sortBy === header.key && !order) ? 'desc' : 'asc' } {(sortBy === header.key) ? 'text-primary' : '' }"></i>
                    </th>
                {/each}
                </thead>
                <tbody>
                {#each users as item}
                    {#if !filter || (item.name && item.name.toString().toLowerCase().indexOf(filter) >= 0) }
                        <tr>
                            <td id="col-kpis-kpiId">{item.id}</td>
                            <td id="col-kpis-kpiNameColumn">{item.name}</td>
                            <td id="col-kpis-role" title="{item.role}">{item.role || 'N/A'}</td>
                            <td id="col-kpis-sectionId" title="{item.team_id}">{item.team_id}</td>
                            <td id="col-kpis-report">{item.position}</td>
                            <td id="col-kpis-organization" title="{item.organization_id}">{item.organization || 'N/A'}</td>
                            <td id="col-kpis-format" >{item.start_date}</td>
                        </tr>
                    {/if}
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="alert alert-primary">
                <i class="fa fa-info-circle fa-3x text-primary"></i>
                <h4 class="text-primary text-uppercase pt-3">
                    No users were found!
                </h4>
            </div>
        {/if}
    </div>
</div>
{/if}
